// extracted by mini-css-extract-plugin
export default {"cardContainer":"DashboardModal_cardContainer__2BTCe"};